export enum Provider {
	CODE = "code",
	FORM = "form",
	CONTACT_PROPERTY = "contactProperty",
	CONTENT = "content",
	AGENT = "agent",
	EVENT = "event",
	LOOKUP = "lookup",
	INVALID = "invalid",
}
